import React from 'react';
import { SvgIcon } from '@mui/material';
import colors from '../../../scss/colors';

function CloseIcon() {
  return (
    <SvgIcon width="20" height="20" viewBox="0 0 20 20" fill="none">
      <path
        d={`M10.0007 0.833008C15.0634 0.833008 19.1673 4.93692 19.1673 9.99967C19.1673 
        15.0624 15.0634 19.1663 10.0007 19.1663C4.9379 19.1663 0.833984 15.0624 0.833984 
        9.99967C0.833984 4.93692 4.9379 0.833008 10.0007 0.833008ZM8.0564 6.75834C7.89182 
        6.59219 7.66996 6.49523 7.43623 6.4873C7.2025 6.47937 6.97458 6.56107 6.79912 
        6.71568C6.62366 6.8703 6.51392 7.08613 6.49238 7.319C6.47084 7.55187 6.53911 
        7.78416 6.68323 7.96834L6.76023 8.05542L8.70357 9.99876L6.76023 11.9439C6.59408 
        12.1085 6.49712 12.3304 6.48919 12.5641C6.48126 12.7978 6.56296 13.0257 6.71758 
        13.2012C6.87219 13.3767 7.08802 13.4864 7.32089 13.5079C7.55376 13.5295 7.78606 
        13.4612 7.97023 13.3171L8.0564 13.241L10.0007 11.2958L11.9449 13.241C12.1095 13.4072 
        12.3313 13.5041 12.5651 13.5121C12.7988 13.52 13.0267 13.4383 13.2022 13.2837C13.3776 
        13.1291 13.4874 12.9132 13.5089 12.6804C13.5305 12.4475 13.4622 12.2152 13.3181 
        12.031L13.242 11.9439L11.2968 9.99967L13.242 8.05542C13.4081 7.89084 13.5051 7.66898 
        13.513 7.43526C13.521 7.20153 13.4393 6.9736 13.2846 6.79814C13.13 6.62268 12.9142 
        6.51295 12.6813 6.4914C12.4485 6.46986 12.2162 6.53814 12.032 6.68226L11.9449 6.75834L10.0007 
        8.70351L8.0564 6.75834Z`}
        fill={colors.NAVY_BLUE}
      />
    </SvgIcon>
  );
}

export default CloseIcon;
